console.log('LOADED: cookies');

// 'regenerator-runtime/runtime' is required to Cookies module
import 'regenerator-runtime/runtime'
import Cookies from 'efile-ui/src/js/modules/cookies/cookies';

const domain = window.location.hostname.indexOf('cms.e-file.pl') !== -1 ? 'cms.e-file.pl' : 'jpk.info.pl';

(function () {
    const cookies = new Cookies(COOKIE_NAME, COOKIE_PATH, '', domain);

    cookies.checkCookie();
    cookies.initialize();
})();
